// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charts-widget-notes h3 {
  margin-bottom: 20px;
  color: #1e293b;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
}
.charts-widget-notes h3::after {
  content: "";
  height: 3px;
  flex: 1 1;
  background: linear-gradient(90deg, #4f46e5, transparent);
  border-radius: 2px;
  margin-left: 12px;
}
.charts-widget-notes .no-notes {
  font-style: italic;
  color: #94a3b8;
  text-align: center;
  padding: 40px 20px;
  background: rgba(248, 250, 252, 0.5);
  border-radius: 12px;
  border: 2px dashed #e2e8f0;
  font-size: 15px;
}
.charts-widget-notes .notes-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 380px;
  overflow-y: auto;
  padding-right: 8px;
}
.charts-widget-notes .notes-grid::-webkit-scrollbar {
  width: 6px;
}
.charts-widget-notes .notes-grid::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}
.charts-widget-notes .notes-grid::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  border-radius: 10px;
}
.charts-widget-notes .notes-grid::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #3730a3, #5b21b6);
}
.charts-widget-notes .note-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(226, 232, 240, 0.6);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.charts-widget-notes .note-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.charts-widget-notes .note-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
  border-color: rgba(79, 70, 229, 0.2);
}
.charts-widget-notes .note-card:hover::before {
  opacity: 1;
}
.charts-widget-notes .note-card .note-header {
  margin-bottom: 12px;
}
.charts-widget-notes .note-card .note-header h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  line-height: 1.3;
}
.charts-widget-notes .note-card .note-body {
  font-size: 14px;
  color: #475569;
  margin-bottom: 16px;
  line-height: 1.5;
}
.charts-widget-notes .note-card .note-body p {
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.charts-widget-notes .note-card .note-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #64748b;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}
.charts-widget-notes .note-card .note-footer span {
  background: rgba(248, 250, 252, 0.8);
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 768px) {
  .charts-widget-notes {
    padding: 16px;
    border-radius: 12px;
  }
  .charts-widget-notes h3 {
    font-size: 1.2rem;
    margin-bottom: 16px;
  }
  .charts-widget-notes .notes-grid {
    gap: 12px;
    max-height: 300px;
  }
  .charts-widget-notes .note-card {
    padding: 16px;
  }
  .charts-widget-notes .note-card .note-header h4 {
    font-size: 1rem;
  }
  .charts-widget-notes .note-card .note-body {
    font-size: 13px;
    margin-bottom: 12px;
  }
  .charts-widget-notes .note-card .note-footer {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
  .charts-widget-notes .note-card .note-footer span {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChartsWidget/ChartsWidget.scss"],"names":[],"mappings":"AACE;EAEE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;EACE,WAAA;EACA,WAAA;EACA,SAAA;EACA,wDAAA;EACA,kBAAA;EACA,iBAAA;AADN;AAKE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAOI;EACE,UAAA;AALN;AAQI;EACE,mBAAA;EACA,mBAAA;AANN;AASI;EACE,qDAAA;EACA,mBAAA;AAPN;AAUI;EACE,qDAAA;AARN;AAYE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,0CAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAYI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qDAAA;EACA,UAAA;EACA,6BAAA;AAVN;AAaI;EACE,2BAAA;EACA,0CAAA;EACA,oCAAA;AAXN;AAaM;EACE,UAAA;AAXR;AAeI;EACE,mBAAA;AAbN;AAeM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAbR;AAiBI;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAfN;AAiBM;EACE,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAfR;AAmBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,6BAAA;AAjBN;AAmBM;EACE,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAjBR;;AAwBA;EACE;IACE,aAAA;IACA,mBAAA;EArBF;EAuBE;IACE,iBAAA;IACA,mBAAA;EArBJ;EAwBE;IACE,SAAA;IACA,iBAAA;EAtBJ;EAyBE;IACE,aAAA;EAvBJ;EAyBI;IACE,eAAA;EAvBN;EA0BI;IACE,eAAA;IACA,mBAAA;EAxBN;EA2BI;IACE,sBAAA;IACA,QAAA;IACA,uBAAA;EAzBN;EA2BM;IACE,eAAA;EAzBR;AACF","sourcesContent":[".charts-widget-notes {\n  h3 {\n    // font-size: 1.4rem;\n    margin-bottom: 20px;\n    color: #1e293b;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    \n    &::after {\n      content: '';\n      height: 3px;\n      flex: 1;\n      background: linear-gradient(90deg, #4f46e5, transparent);\n      border-radius: 2px;\n      margin-left: 12px;\n    }\n  }\n\n  .no-notes {\n    font-style: italic;\n    color: #94a3b8;\n    text-align: center;\n    padding: 40px 20px;\n    background: rgba(248, 250, 252, 0.5);\n    border-radius: 12px;\n    border: 2px dashed #e2e8f0;\n    font-size: 15px;\n  }\n\n  .notes-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    max-height: 380px;\n    overflow-y: auto;\n    padding-right: 8px;\n\n    // Custom scrollbar\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f5f9;\n      border-radius: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: linear-gradient(135deg, #4f46e5, #7c3aed);\n      border-radius: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background: linear-gradient(135deg, #3730a3, #5b21b6);\n    }\n  }\n\n  .note-card {\n    background: #ffffff;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);\n    border: 1px solid rgba(226, 232, 240, 0.6);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 4px;\n      height: 100%;\n      background: linear-gradient(135deg, #4f46e5, #7c3aed);\n      opacity: 0;\n      transition: opacity 0.3s ease;\n    }\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);\n      border-color: rgba(79, 70, 229, 0.2);\n\n      &::before {\n        opacity: 1;\n      }\n    }\n\n    .note-header {\n      margin-bottom: 12px;\n\n      h4 {\n        font-size: 1.1rem;\n        font-weight: 600;\n        color: #1e293b;\n        margin: 0;\n        line-height: 1.3;\n      }\n    }\n\n    .note-body {\n      font-size: 14px;\n      color: #475569;\n      margin-bottom: 16px;\n      line-height: 1.5;\n\n      p {\n        margin: 0;\n        display: -webkit-box;\n        -webkit-line-clamp: 3;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n      }\n    }\n\n    .note-footer {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      font-size: 12px;\n      color: #64748b;\n      padding-top: 12px;\n      border-top: 1px solid #f1f5f9;\n\n      span {\n        background: rgba(248, 250, 252, 0.8);\n        padding: 4px 8px;\n        border-radius: 6px;\n        font-weight: 500;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n      }\n    }\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .charts-widget-notes {\n    padding: 16px;\n    border-radius: 12px;\n\n    h3 {\n      font-size: 1.2rem;\n      margin-bottom: 16px;\n    }\n\n    .notes-grid {\n      gap: 12px;\n      max-height: 300px;\n    }\n\n    .note-card {\n      padding: 16px;\n\n      .note-header h4 {\n        font-size: 1rem;\n      }\n\n      .note-body {\n        font-size: 13px;\n        margin-bottom: 12px;\n      }\n\n      .note-footer {\n        flex-direction: column;\n        gap: 8px;\n        align-items: flex-start;\n\n        span {\n          font-size: 11px;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
